// Single source of truth for user-visible brand identity in the React app.
// The codebase's internal naming (repos, GCP project, service/app names,
// the "foursite" Django project) stays as-is -- only this file and the
// backend's BRAND_NAME/BRAND_DOMAIN/BRAND_SUPPORT_EMAIL settings
// (foursite/settings/common.py) drive what end users actually see, so a
// future rebrand means changing these two places instead of grepping the
// whole codebase again.

export { default as Logo } from "./components/iconComponents/Logo";
export { default as BRAND_FAVICON } from "./assets/favicon.ico";

export const BRAND_NAME = "4-ward.ai";
export const BRAND_DOMAIN = "4-ward.ai";
export const BRAND_SUPPORT_EMAIL = "info@4-ward.ai";
